import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Stepper } from '@progress/kendo-react-layout';
import { createAccountAdsClients } from "../../../Api/LoginApi"
import { useNavigate } from "react-router-dom";
import "../../Login/Login.css"

//Sign Up Step Pages
import SignUp from "../SignUp/SignUp"
import BusinessDetails from './BusinessDetails';
import { sha256 } from 'crypto-hash';

const stepPages = [SignUp, BusinessDetails];

export default function SignUpHub(props) {
    const navigate = useNavigate();

    // Client Information States
    const [userDetails, setUserDetails] = React.useState({
        FirstName: "",
        LastName: "",
        UserEmail: "",

        BusinessName: "",
        ContactNumber: "",
        Address: "",
        City: "",
        Province: "",
        PostalCode: "",
        Country: "",
        // businessEmail:"",
        // platform: "x",

        Password: "",
    });

    // Step States
    const [step, setStep] = React.useState(0);
    const [steps, setSteps] = React.useState([{ label: 'User Details' }, { label: 'Business Details' }]);


    // Instantiate to load as a Component in the return()
    let DisplayComponent = stepPages[step]

    //step vars
    const lastStepIndex = steps.length - 1;
    const isLastStep = lastStepIndex === step;
    const isPreviousStepsValid = steps.slice(0, step);


    // Function to update the data when the user adds Input
    let onDataChange = (field, input) => {
        setUserDetails({
            ...userDetails,
            [field]: input
        })
    }


    const onStepSubmit = React.useCallback(
        () => {
            // setSteps(currentSteps);
            setStep(() => Math.min(step + 1, lastStepIndex));

            if (isLastStep) {
                handleLogin();
            }
        },
        [steps, isLastStep, isPreviousStepsValid, step, lastStepIndex]
    );

    async function handleLogin() {
        try {
            await sha256(userDetails.Password).then(async (hashedPass) => {

                // Update only the Password field in userDetails
                const loginObj = { ...userDetails, Password: hashedPass };

                // console.log(loginObj);

                if (hashedPass) {
                    let loginResult = await createAccountAdsClients(loginObj);
                    // localStorage.setItem("token", loginResult?.data?.token ?? null);

                    localStorage.setItem("token", loginResult?.data.data.token ?? null);
                    localStorage.setItem("userId", loginResult?.data.data.userId ?? null);
                    localStorage.setItem("firstName", loginResult?.data.data.firstName ?? null);
                    localStorage.setItem("lastName", loginResult?.data.data.lastName ?? null);
                    props.setAlertMessage("Successfully created an account")
                    props.onTriggerAlert('success')

                    navigate("/Campaign-Home");
                }
            })
        }
        catch (error) {
            props.setAlertMessage(error?.response?.data ? error?.response?.data.errorMessage : 'Error')
            props.onTriggerAlert('error')
        }
    }


    const onPrevStepClick = React.useCallback(
        (event) => {
            // sets empty every time the page is re-rendered
            onDataChange("FirstName", '')
            onDataChange("LastName", '')
            onDataChange("Password", '')

            event.preventDefault();
            setStep(() => Math.max(step - 1, 0));
            // console.log(step);

            if (step == 0) {
                props.setActivePage("login")
            }
        },
        [step, setStep]
    );

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center", height: "100vh" }}>

            <Stepper style={{ width: "100vw", marginTop: "22px", position: "sticky" }} value={step} linear={true} items={steps} />


            <div
                style={{
                    flex: 1, // Allow the display to take up remaining space
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center', // Center vertically
                    width: '100%', // Optional for full-width alignment
                }}
            >
                {/* Display of the Page */}
                <DisplayComponent
                    onStepSubmit={onStepSubmit}
                    onClick={props.handleBackClick}
                    onDataChange={(field, input) => onDataChange(field, input)}
                    onPrevStepClick={onPrevStepClick}
                />
            </div>

            {/* <div style={{ display: "flex", justifyContent: 'space-between', width: '55vw', marginBottom: '22px' }}>
                <div>
                    <Button
                        style={{ padding: "10px" }}
                        themeColor={'secondary'}
                        onClick={() => props.setActivePage("login")}>
                        Login Home
                    </Button>
                </div>

                <div style={{ alignSelf: "center" }}>Step {step + 1} of {steps.length}</div>

                <div style={{ display: "flex" }}>
                    {step !== 0 ? (
                        <Button
                            style={{ padding: "10px", marginRight: "16px" }}
                            onClick={onPrevStepClick}
                        >
                            Previous
                        </Button>
                    ) : undefined}
                    <Button
                        style={{ padding: "10px", position: "inherit" }}
                        themeColor={'primary'}
                        // disabled={isLastStep ? !isPreviousStepsValid : false}
                        disabled={isFormValid ? false : true}
                        onClick={onStepSubmit}
                    >
                        {isLastStep ? 'Submit' : 'Next'}
                    </Button>
                </div>
            </div> */}
        </div>
    );
};
